import styled from 'styled-components'

import { helpers } from 'styles'

export const Subtitle = styled.div`
	margin-top: 2px;
	font: ${helpers.fonts.subtitle.small};
	opacity: 0.8;
`
